import VibrationPanel from './vibrationPanel/VibrationPanel'

const Autodesk = window.Autodesk  // makes sure the Autodesk forge script is read into a varialbe for use

class VibrtationPanelExtension extends Autodesk.Viewing.Extension {

  constructor (viewer, options) {

    super (viewer, options)
    
    this.panel = new VibrationPanel(viewer, {
      id: 'vibration-react-panel-id',
      title: 'DGA Sensor Panel'
    })
  }

  
  load () {    
    console.log('Viewing.Extension.VibrationPanel loaded')
    this.panel.setVisible(true)
    return true
  }

  
  static get ExtensionId () {
    return 'Viewing.Extension.VibrationPanel'
  }

  
  unload () {
    console.log('Viewing.Extension.VibrationPanel unloaded')
    return true
  }
}

Autodesk.Viewing.theExtensionManager.registerExtension (
  VibrtationPanelExtension.ExtensionId,
  VibrtationPanelExtension)

export default 'Viewing.Extension.VibrationPanel'